module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-8-3fcd2898b3e52548be0bd829b545763f.jpg";